import React from 'react'
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import injectSheet from 'react-jss'
import style from './style'
import LocationSearch from 'components/LocationSearch'
import { messageAction } from 'actions/messageActions'
import tippy from 'tippy.js'
import { startExportAction } from 'actions/exportActions'
import { checkOfflineLimitsAction } from 'actions/applicationActions'

class ExportDropdown extends React.Component {
  state = { showDropdown: false }

  toggle(event) {
    const { state: { showDropdown } } = this
    event.stopPropagation()
    event.preventDefault()
    this.setState({ showDropdown: !showDropdown })
  }

  clickHandler = _ => {
    this.state.showDropdown && this.setState({ showDropdown: false })
  }

  componentDidMount() {
    [this.refs.exportLink, this.refs.floorplanLink]
      .forEach(ref => tippy(ref, { duration: 0, theme: 'topbar', placement: 'bottom' }))
    window.addEventListener('click', this.clickHandler, false)
  }

  componentWillUnmount = _ => {
    window.removeEventListener('click', this.clickHandler)
  }

  render() {
    const { state: { showDropdown }, toggle, props: { startExportAction, checkOfflineLimitsAction, classes } } = this
    return (
      <div className={classes.container}>
        <div>
          <a
            onClick={toggle.bind(this)}
            className={classes.exportButton}
            title='Download PPT, PDF, DOC, CSV, ZIP or Snapshot of your project'
            ref='exportLink'
          >
            <FontAwesomeIcon icon='file-download' className={classes.exportIcon} />
            Export
            <FontAwesomeIcon icon='caret-down' className={classes.caretDownIcon} />
          </a>
        </div>
        <div className={showDropdown ? classes.showDropdown : classes.hideDropdown}>
          <div onClick={startExportAction.bind(null, 'jpeg')} className={classes.dropdownItem}>
            <FontAwesomeIcon icon={['far', 'image']} className={classes.snapshotDropdownIcon} />
            Snapshot
          </div>
          <div onClick={startExportAction.bind(null, 'zip')} className={classes.dropdownItem}>
            <FontAwesomeIcon icon={['far', 'file-archive']} className={classes.dropdownIcon} />
            ZIP
          </div>
          <div onClick={_ => checkOfflineLimitsAction('export', ['csv'])} className={classes.dropdownItem}>
            <FontAwesomeIcon icon={['far', 'file-excel']} className={classes.dropdownIcon} />
            CSV
          </div>
          <div onClick={startExportAction.bind(null, 'pdf')} className={classes.dropdownItem}>
            <FontAwesomeIcon icon={['far', 'file-pdf']} className={classes.dropdownIcon} />
            PDF
          </div>
          <div onClick={_ => checkOfflineLimitsAction('export', ['docx'])} className={classes.dropdownItem}>
            <FontAwesomeIcon icon={['far', 'file-word']} className={classes.dropdownIcon} />
            Word Doc
          </div>
          <div onClick={_ => checkOfflineLimitsAction('export', ['pptx'])} className={classes.dropdownItem}>
            <FontAwesomeIcon icon={['far', 'file-powerpoint']} className={classes.dropdownIcon} />
            PowerPoint
          </div>
        </div>
        <div>
          <a
            onClick={_ => checkOfflineLimitsAction('modal', ['FloorPlanUploader'])}
            className={classes.addFloorPlanButton}
            title='Add a floor plan to the current project'
            ref='floorplanLink'
          >
            <FontAwesomeIcon icon='building' className={classes.addButtonIcon} />
            Add Floor Plan
          </a>
        </div>
        <LocationSearch />
      </div>
    )
  }
}

export default connect(null, { messageAction, startExportAction, checkOfflineLimitsAction })(injectSheet(style)(ExportDropdown))



// WEBPACK FOOTER //
// ./src/components/TopBar/ExportDropdown/index.js